import {useEffect, useState} from 'react';

/**
 * Hook to delay showing skeleton loading states
 * Prevents flash on fast-loading pages by waiting 300ms before rendering
 *
 * @param skipDelay - If true, skip the delay and show immediately (useful for data-loading skeletons after Suspense)
 * @returns Boolean indicating whether to show the skeleton
 */
export const useSkeletonDelay = (skipDelay = false): boolean => {
  const [show, setShow] = useState(skipDelay);

  useEffect(() => {
    if (skipDelay) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setShow(true);
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [skipDelay]);

  return show;
};
